<template>
  <div>
    <Head>
      <link
        rel="canonical"
        :href="$page.props.canonical_url"
        inertia
      >
      <title>{{ seoTitle }}</title>
      <meta
        name="title"
        :content="seoTitle"
      >
      <meta
        name="description"
        :content="seoDescription"
      >
      <meta
        name="keywords"
        :content="seoKeywords"
      >
    </Head>

    <div class="flex justify-center items-center h-screen bg-white">
      <div class="flex flex-col justify-items-center">
        <div class="p-6">
          <AuctionEmbed
            v-if="auction"
            :item="auction"
            @hasWon="auctionHasWon"
            @ended="auctionEnded"
          >
            {{ auction.name }}
          </AuctionEmbed>
          <div v-else>
            Er zijn nog geen veilingen, even geduld!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Head} from '@inertiajs/vue2';
import ActionHandlers from '../../Mixins/ActionHandlers';
import AuctionEmbed from '../../Partials/Products/AuctionEmbed.vue';

export default {
  components: {Head, AuctionEmbed},

  mixins: [ActionHandlers],

  // removes the default layout and the stream
  layout: null,

  props: {
    seoTitle: {
      type: String,
      required: false,
      default: null,
    },

    seoDescription: {
      type: String,
      required: false,
      default: null,
    },

    seoKeywords: {
      type: String,
      required: false,
      default: null,
    },

    auction: {
      type: Object,
      required: false,
      default: null,
    },
  },

  mounted () {
    this.$echo.channel('twitch')
      .listen('TwitchAuctionsUpdated', this.reload);

    if (!this.auction) {
      this.$eventHub.$emit('flashing-light', 'caution');
    }
  },

  destroyed () {
    this.$echo.leaveChannel('twitch');
  },

  methods: {
    auctionHasWon() {
      setTimeout(() => this.reload(), 2000);
    },

    auctionEnded() {
      setTimeout(() => this.reload(), 2000);
    },

    reload() {
      this.$inertia.get(this.route('frontend.twitch.embed'));
    },
  },
};
</script>
